import { render, staticRenderFns } from "./Pxcard.vue?vue&type=template&id=35bb8d48&scoped=true"
import script from "./Pxcard.vue?vue&type=script&lang=js"
export * from "./Pxcard.vue?vue&type=script&lang=js"
import style0 from "./Pxcard.vue?vue&type=style&index=0&id=35bb8d48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bb8d48",
  null
  
)

export default component.exports